import { Component } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { Budget } from '../../store/reselectors/budget.data';
import { OnInit } from '@angular/core';
import { JoiEvent, WFWorker } from 'src/app/store/events.era';
import { EventStatus } from 'globals/store/events.data';
import { eventReadOnlyReselector, eventStatusReselector } from '../../store/reselectors/events.reselector';
import { EntitySelectorData, EntitySelectorDialogComponent } from '../../components/entities/entity-selector.dialog.component';
import { listsMatch } from '../../helpers/helpers';
import { WorkerWithProfile } from 'globals/store/workforce.data';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { automaticallyOnBudgetAdminIdsReselector, canEditBudgetUsersReselector, potentialBudgetWorkforceReselector } from '../../store/reselectors/permissions.reselector';
import { JoiAccount } from 'globals/store/accounts.data';
import { getSet } from 'globals/helpers/helpers';
import { TopMenuComponent } from '../program/top.menu';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { WorkerCardComponent } from 'src/app/components/cards/workforce-card.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommonModule } from '@angular/common';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';

@Component({
    selector: 'budget-admin',
    templateUrl: './budget-admin.html',
    styleUrls: ['../../page.scss', './budget-admin.scss'],
    standalone: true,
    imports: [TopMenuComponent, IdsToItemsPipe, TipTextComponent, AddManageWrapperComponent, WorkerCardComponent, LoaderPaneFragmentComponent, CommonModule],
})
export class BudgetAdminComponent extends Wrapper<BudgetAdminComponent> implements OnInit {
  budget: Budget
  account: Partial<JoiAccount>
  event: JoiEvent
  eventStatus: EventStatus
  workersByEmail: { [key:string]: WFWorker } = {}
  workersByUId: { [key: string]: WFWorker } = {}
  programWorkforce: WorkerWithProfile[] = []
  programWorkforceEmails: Set<string> = new Set()
  canEditBudgetUsers: boolean = false
  adminWorkforceIds: Set<string> = new Set()
  readOnly = false
  closed = true
  traceNames = traceNames;

  ngOnInit() {
    this.subProp(this.store.select('workforce', 'workersByEmail'), 'workersByEmail')
    this.subProp(this.store.select('budget', 'budget'), 'budget')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subProp(this.store.select(eventStatusReselector), 'eventStatus')
    this.selectProp(canEditBudgetUsersReselector, null, 'canEditBudgetUsers')
    this.selectProp(automaticallyOnBudgetAdminIdsReselector, null, 'adminWorkforceIds')
    this.subProp(this.store.select('workforce', 'workersByUId'), 'workersByUId')
    this.selectCallback<{programWorkforce: WorkerWithProfile[], programWorkforceEmails: Set<string>}, any>(potentialBudgetWorkforceReselector, null, ({ programWorkforce, programWorkforceEmails }) => {
      this.programWorkforce = programWorkforce
      this.programWorkforceEmails = programWorkforceEmails
    })
    this.selectProp(eventReadOnlyReselector, null, 'closed')
  }

  async inviteFromWorkforce(event: Event) {
    console.log("Invite from workforce called.")
    const rect = (<HTMLElement>event.target).getBoundingClientRect()

    const selectedEntities = {}
    const workforceProgramEmails = getSet(this.programWorkforce, 'email')
    this.budget.workforceEmails.filter(e => workforceProgramEmails.has(e))
                               .forEach(email => selectedEntities[email] = true)
    const entities = this.programWorkforce.filter(w => w.uid !== this.event.owner_uid)

    const data: EntitySelectorData = { 
      tagOnly: true,
      tagTitle: 'Select Budget Workers',
      selectedEntities,
      noEntitiesMessage: 'No workforce exists with program permission',
      entities, 
      searchPlaceholder: 'Search workforce', 
      entityName: 'Workforce',
      rect,
      entityHolderName: 'Workforce'
    }

    await openDialogGetResult<Promise<string[]>>(this.dialog, EntitySelectorDialogComponent, { width: '300px', data, disableClose: false, backdropClass: 'clear' })
    const selected = Object.entries(selectedEntities).filter(([_, ticked]) => ticked).map(([id, _]) => id)
    if (listsMatch(selected, this.budget.workforceEmails)) return

    // So, the logic around rules for the budget don't work, since budget access is outside all of the permission levels.  Because of this, we'll restrict access to budget to admins / superusers or those on the budget explicitly, by budget.workforceEmails - but they also need to have program permission to do things needed to make the budget work
    this.budget.workforceEmails = selected
    this.budgetService.updateBudget(this.event.eventId, this.budget) // this will fail if the user doesn't have "permissions" for budget

    // however, it's impossible to know whether a user is on the budget without storing that information elsewhere.  So we'll put it on event (and anyone could hack it).  This is only a first check to know whether or not to try and get the budget.
    this.event.budgetWorkforceEmails = selected
    this.eventService.updateEvent(this.event.eventId, { budgetWorkforceEmails: selected }) // this will go through for anyone logistics+ on the event
  }


}